/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { useTranslation } from "react-i18next";

// import authProfileState from "../../states/authProfileState";

import AccessControl from "../functional/AccessControl";

import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

import notificationState from "../../states/notificationState";

import getSchema from "../../lib/api/getSchema";

import DeleteRecordButton from "../input/DeleteRecordButton";
import SaveToExcelButton from "../input/SaveToExcelButton";
// import ApprovalButton from "../input/ApprovalButton";

import { debounce } from "lodash";

import TkCustomerSupplyInputInspectionCreateButton from "../input/TkCustomerSupplyInputInspectionCreateButton";
import TkCustomerSupplyInputInspectionUpdateButton from "../input/TkCustomerSupplyInputInspectionUpdateButton";
import TkCustomerSupplyInputInspectionInputButton from "../input/TkCustomerSupplyInputInspectionInputButton";

function TkCustomerSupplyInputInspection() {

    const [tableSchema, setTableSchema] = useState();
    const [deleteSchema, setDeleteSchema] = useState();

    const [grid, setGrid] = useState();
    const [api, setApi] = useState();
    // const [approvalCtx, setApprovalCtx] = useState();
    const [isEmpty, setIsEmpty] = useState();
    const [inputState, setInputState] = useState(false);

    const [onSelectMst, setOnSelectMst] = useState();

    const [, setNotification] = useRecoilState(notificationState);

    // const authProfile = useRecoilValue(authProfileState);

    const { t } = useTranslation();

    useEffect(() => {

        let mounted = true;

        (async () => {

            let schema = await getSchema("TkVwCustomerSupplyInputInspection");
            let deleteSchema = await getSchema("MomSysInspection")

            if (mounted) {

                setDeleteSchema(deleteSchema)
                setTableSchema(schema);

            }

        })();

        return (() => {

            mounted = false;

        });

    }, []);

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0]);

                    }
                }), 10);

                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0]);
                    }
                }), 10);
            }
        })();

    }, [grid]);

    useEffect(() => {

        if (onSelectMst) {

            if (onSelectMst?.wareHouseCode && onSelectMst?.inputDate) {

                setInputState(true);

            } else {

                setInputState(false)

            }

        }

    }, [onSelectMst])

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    };

    const onInitialized = (grid) => {

        setGrid(grid);

    };

    const onApiInitialized = (api) => {

        setApi(api);

    };

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onNotifyWarning = (msg) => {
        notifyWarning(msg);
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onAppendButtonInFrontOfSearch = () => {
        return (
            <>
                <BasicCrudScreenActionItemLayout>
                    <AccessControl
                        accessTarget={tableSchema && tableSchema.name}
                        accessMethod="POST"
                    >
                        <TkCustomerSupplyInputInspectionCreateButton
                            id={"TkCustomerSupplyInputInspection"}
                            schema={tableSchema}
                            color="primary"
                            createButtonName="input"
                            onSuccess={onSuccess}
                            refresh={api}
                        />
                    </AccessControl>
                </BasicCrudScreenActionItemLayout>
            </>
        );
    };

    return (
        <BasicCrudScreenType
            id="TkCustomerSupplyInputInspection"
            table="TkCustomerSupplyInputInspection"
            view="TkVwCustomerSupplyInputInspection"
            headerTitle={t("term.TkCustomerSupplyInputInspection")}
            noCreate
            noEdit
            noDelete
            noExcel
            onLoadData={onLoadData}
            onInitialized={onInitialized}
            onApiInitialized={onApiInitialized}
            onAppendButtonInFrontOfSearch={onAppendButtonInFrontOfSearch}
            exportFormatItem={() => { }}
        />
    );
}

export default TkCustomerSupplyInputInspection;
